import axios from "axios";
import { API } from "../../backend";
import authHeader from "../auth-header";

const getTaxEngine = () =>
  axios.get(API + "company/tax-engine/", { headers: authHeader() });

// `overrides`: values typed on the page to try instead of the saved ones (nothing is saved).
const testConnection = (overrides = {}) =>
  axios.post(API + "company/tax-engine/test-connection/", overrides, { headers: authHeader() });

const validateOriginAddress = (address = {}) =>
  axios.post(
    API + "company/tax-engine/validate-address/",
    {
      address_line_1: address.address,
      city: address.city,
      state: address.state,
      zip_code: address.zip_code,
      country: address.country,
    },
    { headers: authHeader() }
  );

const TaxEngineService = { getTaxEngine, testConnection, validateOriginAddress };
export default TaxEngineService;
